const MAX_QUANTITY_OF_CHARACTERS_TO_BE_SORTED = 10;

const tokenize = (str: string) => {
  // Normalize: replace dots and dashes with spaces
  const s = String(str)
    .slice(0, MAX_QUANTITY_OF_CHARACTERS_TO_BE_SORTED)
    .replace(/[.-]/g, " ");

  // Split keeping digit groups, remove empty/whitespace-only parts
  const parts = s.split(/(\d+)/).filter((p) => p && p.trim() !== "");

  // Convert pure-digit parts to numbers, trim strings
  return parts.map((p) => (/^\d+$/.test(p) ? Number(p) : p.trim()));
};

export const orderQuestionArray = (a: {name: string}, b: {name: string}) => {
  const ta = tokenize(a.name);
  const tb = tokenize(b.name);

  for (let i = 0; i < Math.max(ta.length, tb.length); i++) {
    if (ta[i] === undefined) return -1; // a is shorter -> comes first
    if (tb[i] === undefined) return 1;  // b is shorter -> comes first

    const pa = ta[i];
    const pb = tb[i];

    const isNumA = typeof pa === "number";
    const isNumB = typeof pb === "number";

    if (isNumA && isNumB) {
      if (pa !== pb) return pa - pb; // numeric compare
    } else if (isNumA !== isNumB) {
      // When one is number and the other is string:
      // keep the string (the parent/label) BEFORE the numeric sub-section
      return isNumA ? 1 : -1;
    } else {
      // both strings -> localeCompare
      const sa = String(pa);
      const sb = String(pb);
      if (sa !== sb) return sa.localeCompare(sb);
    }
  }

  return 0;
};
